import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UntypedFormGroup, UntypedFormControl, Validators } from '@angular/forms';
import { AuthService } from 'src/app/services/auth-service/auth.service';
import { StartUpService } from 'src/app/services/start-up-service/start-up.service';
import { UserLocalSelectionService } from 'src/app/services/dataServices/user-local-selection-service/user-local-selection.service';
import { Router } from '@angular/router';

@Component({
    selector: 'app-dialog-login',
    templateUrl: './dialog-login.component.html',
    styleUrls: ['./dialog-login.component.css'],
    standalone: false
})
export class DialogLoginComponent implements OnInit {
  loginForm = new UntypedFormGroup({
    email: new UntypedFormControl('', [Validators.required, Validators.email, Validators.pattern('^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,}$')]),
    password: new UntypedFormControl('', [Validators.required, Validators.minLength(6)]),
  });
  loading: boolean = false;
  errorLogin: boolean = false;
  showPassword = false;

  constructor(private dialogRef: MatDialogRef<DialogLoginComponent>, private authService: AuthService,
    private startUpService: StartUpService, private localSelectionService: UserLocalSelectionService, private router: Router
    ) { }

  ngOnInit(): void {
    this.authService.loginAnonymous();
    this.authService.getPermission();

    this.authService.checkIfLogedin();
  }

  onCancel(): void {
    this.dialogRef.close();
    // this.router.navigate(['/']); 
  }

  async onLogin() {
    if (this.loginForm.invalid) {
      this.loginForm.markAllAsTouched();
      return;
    } 

    this.errorLogin = false;
    this.loading = true;
    const email = this.loginForm.controls.email.value;
    const password = this.loginForm.controls.password.value;
    try {
      const loginResponse = await this.authService.login(true, email, password);
      if (loginResponse === 'invalid_credentials') {
        this.errorLogin = true;
      } else if (loginResponse === 'error') {
        this.dialogRef.close('error');
      } else if (loginResponse === 'success') {
        await this.startUpService.handleLogin();
        this.dialogRef.close('success');
        this.router.navigate(['marktplatz']);
      }
    } finally {
      this.loading = false;
    }
  }

  goToRegister() {
    let selectedPkg = this.localSelectionService.getSelection('selectedPackage');
    if (selectedPkg) {
      this.localSelectionService.clearSelection('selectedPackage');
      this.localSelectionService.setSelection(selectedPkg, 'selectedPackage-register');
    }
  }

  clearValue(field: string) {
    this.loginForm.get(field)?.setValue('');
  }

}
